import { IconButton } from '@mui/material';
import { styled } from '~/themes';
import CloseIcon from '~/assets/images/icons/close.svg';

type SearchPrefixProps = {
  onClearClick: () => void;
  isSearching?: boolean;
  showSearchIcon?: boolean;
};

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  'width': theme.spacing(2.2),
  'height': theme.spacing(2.2),
  'marginRight': theme.spacing(1),
  '& > img': {
    objectFit: 'scale-down',
  },
}));

export const SearchInputSuffix: React.FC<SearchPrefixProps> = ({
  isSearching,
  onClearClick,
}) =>
  isSearching && (
    <StyledIconButton onClick={onClearClick} size='large'>
      <img alt='clear-icon' src={CloseIcon} width={22} height={22} />
    </StyledIconButton>
  );
